export class SquidexCommunication {
  // OData request
  get(url: string): Promise<Array<Record<string, any>>> {
    return new Promise(resolve => {
      fetch(url, {
        method: "GET", // or 'PUT'
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + process.env.VUE_APP_TOKEN,
        },
      })
        .then(response => response.json())
        .then(data => {
          console.log("Success:", data);
          resolve(data.items.map((item: any) => (item = item.data)));
        })
        .catch(error => {
          console.error("Error: ", error);
        });
    });
  }

  fetchToken(): Promise<string> {
    return new Promise(resolve => {
      fetch(process.env.VUE_APP_SQUIDEX_URL, {
        method: "POST", // or 'PUT'
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `grant_type=client_credentials&client_id=${process.env.VUE_APP_CLIENT_ID}&client_secret=${process.env.VUE_APP_CLIENT_SECRET}&scope=squidex-api`,
      })
        .then(response => response.json())
        .then(res => {
          resolve(res.access_token);
        })
        .catch(error => {
          console.error("Error: ", error);
        });
    });
  }

  // GraphQL request
  fetchGraphQL(url: string, query: any): Promise<object> {
    const token = localStorage.getItem("squidex-token");
    return new Promise(resolve => {
      fetch(url, {
        method: "POST", // or 'PUT'
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({ query }),
      })
        .then(response => {
          if (response.status > 200) throw response;
          else return response.json();
        })
        .then(res => {
          console.log("Success:", res);
          resolve(res.data);
        })
        .catch(error => {
          if (error.status > 400) {
            console.log("Unauthorized\nFetching token ...");
            this.fetchToken().then(newToken => {
              localStorage.setItem("squidex-token", newToken);
              resolve(this.fetchGraphQL(url, query));
            });
            /*             this.fetchGraphQL(url, query); */
          } else console.error("Error: ", error);
        });
    });
  }
}
